import { Store } from 'stores/type';
import { SFX, MUSIC } from 'constants/audio';
import EventsManager from 'managers/events.manager';

import VolumeManager from './volume';
import SoundsManager from './sounds';
import SfxManager from './sfx';
import MusicManager from './music';
import MusicPlayer from './player';

export class AudioManagerClass {
  public context!: AudioContext;
  public player!: MusicPlayer;
  public sounds!: SoundsManager;
  public volume!: VolumeManager;
  public sfx!: SfxManager;
  public music!: MusicManager;

  public init(store: Store) {
    if ('AudioContext' in window) {
      this.context = new (window as any).AudioContext();
    } else if ('webkitAudioContext' in window) {
      // eslint-disable-next-line new-cap
      this.context = new (window as any).webkitAudioContext();
    } else {
      store.commit('AUDIO_DISABLED');
      return;
    }

    this.player = new MusicPlayer(this, this.context, store);
    this.sounds = new SoundsManager(this.context);

    this.volume = new VolumeManager(this.context, store);
    this.sfx = new SfxManager(this.playSFX);
    this.music = new MusicManager(this, this.playMusic);

    EventsManager.once('AUDIO_EXTENSION', () => {
      this.sounds.add(SFX, this.sfx.sounds);
      this.sounds.add(MUSIC, this.music.sounds);

      window.setTimeout(() => this.sounds.loadAll(), 0);
    });

    this.initInteraction();
  }
  private initInteraction() {
    if (!this.context) return;

    const handler = () => {
      this.context.resume();
      document.removeEventListener('mousedown', handler, false);
      document.removeEventListener('touchstart', handler, false);
    };
    document.addEventListener('mousedown', handler, false);
    document.addEventListener('touchstart', handler, false);
  }

  public onTrackFinished() {
    this.music.onTrackFinished();
  }

  public playMusic = (name: string) => {
    this.player.play(name);
  }
  public playSFX = (name: string) => {
    const sound = this.sounds.get(name);
    if (!sound) return;
    if (!sound.buffer) return;
    if (!this.volume.canPlay(SFX)) return;
    if (!this.context) return;

    const source = this.context.createBufferSource();
    source.buffer = sound.buffer;

    let node = this.volume.sfx;
    if (typeof sound.volume === 'number') {
      node = this.context.createGain();
      node.gain.setValueAtTime(sound.volume / 100, this.context.currentTime);
      node.connect(this.volume.sfx);

      source.onended = () => node.disconnect();
    }
    source.connect(node);

    source.start(0, 0);
  }
}

export default new AudioManagerClass();
